import { Container as ContainerMaterial } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export const TitleContainer = styled.div`
  background-color: ${COLORS.lightGray};
  display: flex;
  justify-content: center;
`

export const Container = styled(ContainerMaterial)`
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 4vh;
  padding: 0;
  position: relative;
  width: 610px;
  z-index: 2;
  background: #fff;
  @media (max-width: 610px) {
    width: 80%;
    text-align: center;
    margin-top: -10vh;
  }
`
